if (!customElements.get('wepbio-purchase-options')) {
  customElements.define(
    'wepbio-purchase-options',
    class WepbioPurchaseOptions extends HTMLElement {
      connectedCallback() {
        this.bindControls();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (String(data.sectionId) !== String(this.dataset.sectionId)) return;

            const source = data.html?.getElementById(`WepbioPurchaseOptions-${this.dataset.sectionId}`);
            if (!source) {
              if (this.sellingPlanInput) {
                this.sellingPlanInput.value = '';
                this.sellingPlanInput.disabled = true;
              }
              this.hidden = true;
              return;
            }

            const previousType = this.querySelector('[data-purchase-type]:checked')?.value;
            const previousPlan = this.sellingPlanSelect?.value;
            this.innerHTML = source.innerHTML;
            this.hidden = false;
            this.bindControls(previousType, previousPlan);
          });
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      bindControls(previousType = 'one_time', previousPlan = '') {
        this.purchaseTypeInputs = [...this.querySelectorAll('[data-purchase-type]')];
        this.sellingPlanSelect = this.querySelector('[data-selling-plan-select]');
        this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');
        this.planSelector = this.querySelector('[data-plan-selector]');

        if (previousPlan && this.sellingPlanSelect) {
          const matchingOption = [...this.sellingPlanSelect.options].find((option) => option.value === previousPlan);
          if (matchingOption) this.sellingPlanSelect.value = previousPlan;
        }

        const subscriptionInput = this.querySelector('[data-purchase-type="subscription"]');
        if (previousType === 'subscription' && subscriptionInput && !subscriptionInput.disabled) {
          subscriptionInput.checked = true;
        }

        this.purchaseTypeInputs.forEach((input) => input.addEventListener('change', () => this.updateState()));
        this.sellingPlanSelect?.addEventListener('change', () => this.updateState());
        this.updateState();
      }

      updateState() {
        const selectedType = this.querySelector('[data-purchase-type]:checked')?.value || 'one_time';
        const isSubscription = selectedType === 'subscription' && Boolean(this.sellingPlanSelect?.value);

        this.querySelectorAll('.wepbio-purchase-option').forEach((option) => {
          option.classList.toggle('is-selected', option.querySelector('input')?.checked === true);
        });

        if (this.planSelector) this.planSelector.hidden = !isSubscription;
        if (this.sellingPlanInput) {
          this.sellingPlanInput.value = isSubscription ? this.sellingPlanSelect.value : '';
          this.sellingPlanInput.disabled = !isSubscription;
        }
      }
    }
  );
}
